<template>
	<mounting-portal mount-to="#portalvue-single-podcast">
		<div class="relative w-full bg-black md:bg-gradient-to-b md:from-black md:via-gray-900 md:to-black md:px-5 mb-4">
			<div class="w-full container md:mx-auto">
				<div class="flex">
					<div class="w-full container mx-auto flex flex-col md:flex-row-reverse" style="min-height: 380px;">
						<div class="w-full md:w-1/2 mt-10">
							<div class="flex flex-col w-full items-center md:items-end justify-center space-y-4 text-center md:text-right px-4 mt-10 md:pl-12">
								<h4 class="text-gray-200 text-3xl text-waheed">{{ episode.podcast.name }}: {{ episode.episode_name }}</h4>
								<p class="text-gray-300 text-xl break-normal text-waheed leading-10">{{ episode.episode_description }}</p>
							</div>

							<div class="flex items-center justify-between flex-col md:flex-row">
								<div class="mt-10 md:mb-16 flex flex-col items-center md:items-start z-10">
									<div class="w-full flex items-center md:justify-end justify-center space-x-2">
										<a :href="`https://twitter.com/intent/tweet?text=${episode.episode_name_en}&url=${getEpisodeCopyLink(episode.guid)}`" class="flex justify-center items-center content-center h-8 w-8 rounded-full bg-mh-gray-23 hover:scale-110 transform transition duration-300" target="_blank" title="Twitter">
											<svg class="w-6 h-6 text-blackish" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
												<path
													d="M9.31 18.25C14.7819 18.25 17.7744 13.4403 17.7744 9.26994C17.7744 9.03682 17.9396 8.83015 18.152 8.73398C18.8803 8.40413 19.8249 7.49943 18.8494 5.97828C18.2031 6.32576 17.6719 6.51562 16.9603 6.74448C15.834 5.47393 13.9495 5.41269 12.7514 6.60761C11.9785 7.37819 11.651 8.52686 11.8907 9.62304C9.49851 9.49618 6.69788 7.73566 5.1875 5.76391C4.39814 7.20632 4.80107 9.05121 6.10822 9.97802C5.63461 9.96302 5.1716 9.82741 4.75807 9.58305V9.62304C4.75807 11.1255 5.75654 12.4191 7.1444 12.7166C6.70672 12.8435 6.24724 12.8622 5.80131 12.771C6.19128 14.0565 7.87974 15.4989 9.15272 15.5245C8.09887 16.4026 6.79761 16.8795 5.45806 16.8782C5.22126 16.8776 4.98504 16.8626 4.75 16.8326C6.11076 17.7588 7.69359 18.25 9.31 18.2475V18.25Z"
													stroke="none"
													stroke-linecap="round"
													stroke-linejoin="round"
													stroke-width="1.5"
												/>
											</svg>
										</a>

										<a :href="`https://www.facebook.com/dialog/share?app_id=${facebook_app_id}&href=${getEpisodeCopyLink(episode.guid)}&redirect_uri=${getEpisodeCopyLink(episode.guid)}`" class="flex justify-center items-center content-center h-8 w-8 rounded-full bg-mh-gray-23 hover:scale-110 transform transition duration-300" target="_blank" title="Facebook">
											<svg class="w-5 h-5 text-blackish" version="1.1" viewBox="0 0 56.693 56.693" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
												<path d="M40.43,21.739h-7.645v-5.014c0-1.883,1.248-2.322,2.127-2.322c0.877,0,5.395,0,5.395,0V6.125l-7.43-0.029  c-8.248,0-10.125,6.174-10.125,10.125v5.518h-4.77v8.53h4.77c0,10.947,0,24.137,0,24.137h10.033c0,0,0-13.32,0-24.137h6.77  L40.43,21.739z" />
											</svg>
										</a>

										<button class="flex justify-center items-center content-center h-8 w-8 rounded-full bg-mh-gray-23 hover:scale-110 transform transition duration-300" href target="_blank" title="Link" type="button" v-clipboard:copy="getEpisodeCopyLink(episode.guid)">
											<svg class="w-6 h-6 text-blackish" fill="none" viewBox="0 0 24 24">
												<path d="M16.75 13.25L18 12C19.6569 10.3431 19.6569 7.65685 18 6V6C16.3431 4.34315 13.6569 4.34315 12 6L10.75 7.25" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
												<path d="M7.25 10.75L6 12C4.34315 13.6569 4.34315 16.3431 6 18V18C7.65685 19.6569 10.3431 19.6569 12 18L13.25 16.75" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
												<path d="M14.25 9.75L9.75 14.25" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
											</svg>
										</button>
									</div>
									<h3 class="text-mh-gray-23 text-sm mt-2">Share</h3>
								</div>

								<div class="mt-10 mb-16 flex flex-col items-center md:items-start">
									<div class="w-full flex items-center md:justify-end justify-center space-x-2">
										<div class="flex justify-center w-10" v-if="episode.spotify">
											<a :href="episode.spotify + '?ref=mhr-hme-podcastbanner'" target="_blank" title="Spotify">
												<img :src="ASSET_LINK('/svg/spotify-logo.svg')" alt="Spotify Logo" class="w-12 h-12" />
											</a>
										</div>

										<div class="flex justify-center w-10" v-if="episode.itunes">
											<a :href="episode.itunes + '?ref=mhr-hme-podcastbanner'" target="_blank" title="Apple Podcasts">
												<img :src="ASSET_LINK('/svg/itunes-logo.svg')" alt="Apple Podcasts Logo" class="w-8 h-8" />
											</a>
										</div>

										<div class="flex justify-center w-10" v-if="episode.soundcloud">
											<a :href="episode.soundcloud + '?ref=mhr-hme-podcastbanner'" target="_blank" title="SoundCloud">
												<img :src="ASSET_LINK('/svg/soundcloud.svg')" alt="SoundCloud Logo" class="w-8 h-8" />
											</a>
										</div>

										<div class="flex justify-center w-10" v-if="episode.google">
											<a :href="episode.google + '?ref=mhr-hme-podcastbanner'" target="_blank" title="Google Podcasts">
												<img :src="ASSET_LINK('/svg/google-podcasts.svg')" alt="Google Podcasts Logo" class="w-8 h-8" />
											</a>
										</div>

										<div class="flex justify-center w-10" v-if="episode.anchor">
											<a :href="episode.anchor + '?ref=mhr-hme-podcastbanner'" target="_blank" title="Anchor FM">
												<img :src="ASSET_LINK('/svg/anchorfm.svg')" alt="Anchor FM Logo" class="w-8 h-8" />
											</a>
										</div>
									</div>

									<h3 class="text-mh-gray-23 text-sm">Listen on</h3>
								</div>
							</div>
						</div>

						<div class="w-full md:w-1/2">
							<div class="relative md:h-full">
								<img :src="episode.cover_art.small" class="object-cover h-full w-full md:rounded-r-full" />

								<div class="absolute w-full h-full top-0 flex justify-center items-start -mt-6 md:mt-0 md:ml-8 md:items-center md:justify-end z-0" v-if="!playing">
									<button class="hover:scale-110 text-white transform transition duration-300" v-on:click="initPlaying(episode.id)">
										<svg class="w-16 h-16" data-name="Group 1" id="Group_1" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
											<path d="M20.534,37.374a1.774,1.774,0,0,1-.817-.2,1.813,1.813,0,0,1-.967-1.611V17.437a1.81,1.81,0,0,1,.967-1.61,1.774,1.774,0,0,1,.817-.2,1.756,1.756,0,0,1,1.035.336l12.493,9.063a1.828,1.828,0,0,1,0,2.95L21.57,37.039A1.759,1.759,0,0,1,20.534,37.374Z" data-name="Subtraction 1" id="Subtraction_1" transform="translate(-0.75 -1.626)" />
											<path d="M50,25A25,25,0,1,1,25,0,25,25,0,0,1,50,25ZM21.219,15.916a1.563,1.563,0,0,0-2.469,1.272V32.813a1.562,1.562,0,0,0,2.469,1.272l10.938-7.812a1.562,1.562,0,0,0,0-2.544L21.219,15.916Z" fill="currentColor" id="play" transform="translate(0 0)" />
										</svg>
									</button>
								</div>

								<div class="absolute w-full h-full top-0 flex justify-center items-start -mt-6 mb-5 md:mt-0 md:ml-16 md:items-center md:justify-end z-0" v-if="playing">
									<div class="bg-black rounded-lg px-1">
										<lottie-player autoplay background="transparent" class="w-32" loop speed="1" src="https://assets1.lottiefiles.com/packages/lf20_1xbk4d2v.json"></lottie-player>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="w-full left-0 bottom-0" v-show="episode.id === nowPlaying">
					<div class="container mx-auto bg-black py-4 opacity-75">
						<vue-plyr ref="plyr">
							<audio controls playsinline>
								<source :src="episode.audio_src" type="audio/mpeg" />
							</audio>
						</vue-plyr>
					</div>
				</div>
			</div>
		</div>
	</mounting-portal>
</template>
<script>
export default {
  props: ["episode", "currently_selected", "facebook_app_id"],
  data() {
    return {
      nowPlaying: null,
      playing: false,
    };
  },

  methods: {
    initPlaying(id) {
      self = this;
      this.nowPlaying = id;

      this.$refs.plyr.player.on("playing", function () {
        self.playing = true;
      });

      this.$refs.plyr.player.on("play", function () {
        self.playing = true;
      });

      this.$refs.plyr.player.on("pause", function () {
        self.playing = false;
      });

	   this.$refs.plyr.player.play();

      axios
        .post("podcast/play", {
          episode: this.episode.id,
        })
        .then((resp) => {
          console.log(resp);
        })
        .catch((e) => {
          console.error(e);
        });
    },

    getEpisodeCopyLink(guid) {
      return `${window.location.origin}/podcast/${guid}`;
    },
  },

  mounted() {
    if (this.currently_selected) {
      this.nowPlaying = this.currently_selected;

      setTimeout(() => {
        this.initPlaying(this.currently_selected);
		
		//this.$refs.plyr.player.play();
		
      }, 0);
    }
  },
};
</script>